import { CheckMarkColor } from "components/home/benifits/list/logic/constants/сheckMarkColor";
import { FontColor } from "constants/fontColor";

export type BenefitsStaticItem = {
    title?: string;
    titleTablet?: string;
    titleMobile?: string;
    itemClass: string;
    list?: string[];
    checkMarkColor?: CheckMarkColor;
    fontColor?: FontColor;
    titleFontColor?: FontColor;
};

export const BENEFITS_STATIC: BenefitsStaticItem[] = [
    {
        title: "Where innovations meet education",
        titleTablet: "Where innovation meets education",
        titleMobile: "Where innovation <br> meets education",
        itemClass: "home-benefits__innovations",
        list: [
            "Classes are designed with the latest trends and technologies to keep children ahead of the curve",
            "Applying theoretical knowledge on a specially-designed training platform KidsCrafts.shop",
            "Сomfortable learning and interaction environment for all children",
            "Preparing for a successful future in the world shaped by innovations",
        ],
        checkMarkColor: CheckMarkColor.Pink,
        titleFontColor: FontColor.Pink600,
        fontColor: FontColor.Black,
    },
    {
        itemClass: "home-benefits__image_boy_kidpreneur",
    },
    {
        title: "Opportunities for kids",
        itemClass: "home-benefits__opportunities",
        list: [
            "Gain insights into e-commerce, financial literacy and business basics",
            "Develop problem-solving skills and critical thinking",
            "Active participation in the learning process through interactive tasks",
            "Develop resilience and curiosity to navigate the business world",
        ],
        titleFontColor: FontColor.Pink600,
        checkMarkColor: CheckMarkColor.Pink,
        fontColor: FontColor.Black,
    },
    {
        title: "Turning young learners into future leaders",
        itemClass: "home-benefits__turning",
        list: [
            "Acquiring future-proof skills through tailored classes on entrepreneurship, emerging technologies, and more",
            "Empowering kids to innovate, create, building the confidence to turn ideas into reality",
            "Inclusive environment fostering social interaction and integration",
            "Cultivating a success-oriented mindset and entrepreneurial spirit",
        ],
        checkMarkColor: CheckMarkColor.White,
        titleFontColor: FontColor.White,
        fontColor: FontColor.White,
    },
];
